import React from "react";

import "../styles/TermsAndConditions.css";

export default function TermsAndConditions() {
  return (
    <div className="terms-and-conditions-container">
      <h1>Terms and Conditions</h1>
      <section>
        <h2>Overview</h2>
        <p>
          This website is operated by Charles Timmins Ltd. Throughout the site,
          the terms “we,” “us,” and “our” refer to Charles Timmins Ltd. Charles
          Timmins Ltd offers this website, including all information, tools, and
          services available from this site to you, the user, conditioned upon
          your acceptance of all terms, conditions, policies, and notices stated
          here.
        </p>
        <p>
          By visiting our site and/or purchasing something from us, you engage
          in our “Service” and agree to be bound by the following terms and
          conditions (“Terms of Service,” “Terms”), including any additional
          terms and conditions and policies referenced herein or available via
          hyperlink. These Terms of Service apply to all users of the site,
          including but not limited to browsers, vendors, customers, merchants,
          and contributors of content.
        </p>
        <p>
          Please read these Terms of Service carefully before accessing or using
          our website. By accessing or using any part of the site, you agree to
          be bound by these Terms of Service. If you do not agree to all the
          terms and conditions of this agreement, you may not access the website
          or use any services. If these Terms of Service are considered an
          offer, acceptance is expressly limited to these Terms of Service.
        </p>
        <p>
          Any new features or tools added to the current store shall also be
          subject to the Terms of Service. You can review the most current
          version of the Terms of Service at any time on this page. We reserve
          the right to update, change, or replace any part of these Terms of
          Service by posting updates and changes to our website. It is your
          responsibility to check this page periodically for changes. Your
          continued use of or access to the website following the posting of any
          changes constitutes acceptance of those changes.
        </p>
        <p>
          Our store is hosted on Shopify Inc. They provide us with the online
          e-commerce platform that allows us to sell our products and services
          to you.
        </p>
      </section>

      <section>
        <h2>Section 1 - Online Store Terms</h2>
        <p>
          By agreeing to these Terms of Service, you confirm that you are at
          least the age of majority in your state or province of residence, or
          that you are the age of majority in your state or province of
          residence and have given us your consent to allow any of your minor
          dependents to use this site.
        </p>
        <p>
          You may not use our products for any illegal or unauthorized purposes,
          nor may you violate any laws in your jurisdiction (including but not
          limited to copyright laws) when using the Service.
        </p>
        <p>You must not transmit any worms, viruses, or destructive code.</p>
        <p>
          A breach or violation of any of the Terms will result in the immediate
          termination of your Services.
        </p>
      </section>

      <section>
        <h2>Section 2 - General Conditions</h2>
        <p>
          We reserve the right to refuse service to anyone for any reason at any
          time.
        </p>
        <p>
          You understand that your content (excluding credit card information)
          may be transferred unencrypted and involve (a) transmissions over
          various networks and (b) changes to conform to technical requirements
          of connecting networks or devices. Credit card information is always
          encrypted during transfer over networks.
        </p>
        <p>
          You agree not to reproduce, duplicate, copy, sell, resell, or exploit
          any portion of the Service, use of the Service, or access to the
          Service or any contact on the website through which the service is
          provided, without express written permission from us.
        </p>
        <p>
          Headings used in this agreement are for convenience only and will not
          limit or otherwise affect these Terms.
        </p>
      </section>

      <section>
        <h2>
          Section 3 - Accuracy, Completeness, and Timeliness of Information
        </h2>
        <p>
          We are not responsible if information on this site is not accurate,
          complete, or current. The material provided is for general information
          only and should not be solely relied upon without consulting primary,
          accurate, complete, or timely sources. Reliance on the material on
          this site is at your own risk.
        </p>
        <p>
          Historical information on this site is provided for reference and is
          not current. We reserve the right to modify the contents of the site
          at any time but have no obligation to update any information. It is
          your responsibility to monitor changes to the site.
        </p>
      </section>

      <section>
        <h2>Section 4 - Modifications to the Service and Prices</h2>
        <p>Prices for our products are subject to change without notice.</p>
        <p>
          We reserve the right to modify or discontinue the Service (or any part
          or content thereof) at any time without notice.
        </p>
        <p>
          We are not liable to you or any third party for any modifications,
          price changes, suspensions, or discontinuances of the Service.
        </p>
      </section>

      <section>
        <h2>Section 5 - Products or Services</h2>
        <p>
          Certain products or services may only be available online through the
          website. These products may have limited quantities and are subject to
          return or exchange only as per our Return Policy.
        </p>
        <p>
          We make every effort to display our products, including colors and
          images, as accurately as possible. However, we cannot guarantee that
          your computer monitor’s display will reflect the true color.
        </p>
        <p>
          Our products, including shorts with a zip pocket design, are subject
          to availability and may be discontinued at our discretion.
        </p>
        <p>
          We reserve the right to limit sales of our products or services to any
          individual, geographic region, or jurisdiction on a case-by-case
          basis.
        </p>
        <p>
          The swimming trunks offered by Charles Timmins include a unique
          waterproof pocket feature located inside the right-hand pocket. While
          the pocket is designed to provide protection against water ingress
          under specified conditions, Charles Timmins disclaims liability for
          any damage to items stored in the waterproof pocket arising from, but
          not limited to, the following reasons:
        </p>
        <ul>
          <li>
            <strong>Incorrect Use:</strong> Failure to properly close and secure
            the waterproof pocket by zipping it fully into the locked position
            may compromise its waterproof properties.
          </li>
          <li>
            <strong>Physical Damage:</strong> Damage caused to the rubberized
            pocket material, such as tears, punctures, or abrasions from sharp
            or abrasive items, will nullify its waterproof capabilities.
          </li>
          <li>
            <strong>Exceeding Depth Limits:</strong> The waterproof pocket is
            designed to withstand water pressure up to a depth of 5 meters
            (approximately 16 feet). Usage beyond this depth may lead to water
            ingress.
          </li>
          <li>
            <strong>Improper Maintenance or Care:</strong> Neglecting to follow
            proper cleaning and maintenance guidelines for the swimming trunks,
            such as exposure to harsh chemicals or improper storage, may degrade
            the waterproofing materials.
          </li>
          <li>
            <strong>External Forces:</strong> Damage caused by external forces
            or environmental factors beyond normal use, such as extreme impacts,
            may affect the waterproof pocket's functionality.
          </li>
        </ul>
        <p>
          By purchasing and using our swimming trunks, you acknowledge and
          accept that Charles Timmins is not liable for any damage to personal
          items resulting from improper use, care, or conditions that compromise
          the waterproof pocket's performance. We recommend testing the pocket
          for waterproof integrity before storing valuable or sensitive items
          and adhering strictly to the product care and usage guidelines
          provided.
        </p>
        <p>
          If you have any questions about the use or limitations of the
          waterproof pocket, please contact our customer service team.
        </p>
      </section>

      <section>
        <h2>Section 6 - Accuracy of Billing and Account Information</h2>
        <p>
          We reserve the right to refuse any order you place. We may limit or
          cancel quantities purchased per person, household, or order at our
          discretion. This may include orders placed under the same customer
          account, billing address, or payment method.
        </p>
        <p>
          You agree to provide accurate, current, and complete purchase and
          account information for all purchases. You must promptly update your
          account information, including email addresses and payment details,
          for transaction completion and communication purposes.
        </p>
        <p>For more details, review our Returns Policy.</p>
      </section>

      <section>
        <h2>Section 20 - Contact Information</h2>
        <p>Questions about the Terms of Service should be directed to us at:</p>
        <p>
          Charles Timmins Ltd
          <br />
          Email: charlestimmins@gmail.com
          <br />
          Address: Hazeldene, The Lane, Gate Helmsley, York, England, YO41 1JT
        </p>
      </section>
    </div>
  );
}
